export enum CarouselBtnStyles {
    UNDEFINED = '',
    SQUARE = 'square',
    CIRCLE = 'circle',
}
